import Types from "./Types";

export const PackagesLoading = (payload) => ({
  type: Types.PACKAGES_LOADING,
  payload,
});

export const GetPackagesSuccess = (payload) => ({
  type: Types.GET_PACKAGES_SUCCESS,
  payload,
});

export const GetPackageDetailsSuccess = (payload) => ({
  type: Types.GET_PACKAGE_DETAILS_SUCCESS,
  payload,
});

export const GetPackageItemsSuccess = (payload) => ({
  type: Types.GET_PACKAGE_ITEMS_SUCCESS,
  payload,
});

export const GetAvailablePackageServicesSuccess = (payload) => ({
  type: Types.GET_AVAILABLE_PACKAGE_SERVICES_SUCCESS,
  payload,
});

export const ClearAvailablePackageServices = () => ({
  type: Types.CLEAR_AVAILABLE_PACKAGE_SERVICES,
});
